import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import {
  Tabs, Card, CardSlider, Toggle, Modal, BUTTON_TYPES, CARD_SLIDER_CARD_SIZES, BREAKPOINTS
} from 'day8-react/build/new-components';
import { useKeyHack } from 'day8-react';

const Highlights = ({ highlights }) => {
  const key = useKeyHack();
  const filterButtons = [
    {
      text: 'All',
      cat: [41, 40]
    },
    {
      text: 'Parties',
      cat: 41
    },
    {
      text: 'Activities',
      cat: 40
    }
  ];
  const filterOptions = filterButtons.map(button => ({
    ...button,
    items: button.text === 'All'? highlights.filter(h => h.categories): highlights.filter(highlight => highlight.categories && highlight.categories.includes(button.cat))
  }));
  return (
    <Fragment>
      <h2 className="d8-u-ls-sm margin-bottom-md text-center">Highlights</h2>
      <Media key={key} query={{ minWidth: BREAKPOINTS.SM }}>
        {matches => (
          <Tabs filterOptions={filterOptions} centerOptions noBackground buttonType={BUTTON_TYPES.FILTER_FILL} hasOptionsModal={!matches}>
            {({ activeFilter }) => (
              <div className="margin-top-md">
                <CardSlider cardSize={CARD_SLIDER_CARD_SIZES.XS_WIDE}>
                  {filterOptions[activeFilter].items.map(item => (
                    <Toggle key={JSON.stringify(item)}>
                      {({ toggle, on }) => (
                        <Fragment>
                          <Card
                            template="ImageCard"
                            imageCardTemplate="Basic"
                            heading={item.title.rendered}
                            bgImage={{ url: item.featured_image_src, alt: item.title.rendered }}
                            whiteFont
                            overlay
                            size="xs"
                            onClick={toggle}
                          />
                          <Modal style={{ width: 'var(--max-width-xxs)', minWidth: 'unset' }} template="MediaModal" on={on} toggle={toggle} title={item.title.rendered.replace(/<[^>]*>/g, '')} text={item && item.content && item.content.rendered && item.content.rendered.replace(/<[^>]*>/g, '')} image={{ url: item.featured_image_src, alt: item.title.rendered.replace(/<[^>]*>/g, '') }} video={item.acf && item.acf.video} />
                        </Fragment>
                      )}
                    </Toggle>
                  ))}
                </CardSlider>
              </div>
            )}
          </Tabs>
        )}
      </Media>
    </Fragment>
  );
};
Highlights.propTypes = {
  highlights: PropTypes.array
};
export default Highlights;
